import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=4933d21a&scoped=true"
import script from "./TypeList.vue?vue&type=script&lang=js"
export * from "./TypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4933d21a",
  null
  
)

export default component.exports